import { render, staticRenderFns } from "./CopyQuoteModal.vue?vue&type=template&id=21660006&scoped=true"
import script from "./CopyQuoteModal.vue?vue&type=script&lang=js"
export * from "./CopyQuoteModal.vue?vue&type=script&lang=js"
import style0 from "./CopyQuoteModal.vue?vue&type=style&index=0&id=21660006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21660006",
  null
  
)

export default component.exports